import { useMemo } from 'react'
import { type Capabilities, Capability } from '../../models/Onboarding'
import { useCalendarCapability } from './useCalendarCapability'
import { useContactCapability } from './useContactCapability'
import { useFinancialPlanningCapability } from './useFinancialPlanningCapability'
import { useMailCapability } from './useMailCapability'
import { useZoomCapability } from './useZoomCapability'

export const useOnboardingCapabilities = (): Capabilities => {
  const calendarCapability = useCalendarCapability()
  const contactCapability = useContactCapability()
  const financialPlanningCapability = useFinancialPlanningCapability()
  const mailCapability = useMailCapability()
  const zoomCapability = useZoomCapability()

  return useMemo(() => {
    const { isLoading: isCalendarLoading, ...calendarSource } = calendarCapability
    const { isLoading: isContactLoading, ...contactSource } = contactCapability
    const { isLoading: isFPLoading, ...financialPlanning } = financialPlanningCapability
    const { isLoading: isMailLoading, ...mail } = mailCapability
    const { isLoading: isZoomLoading, ...zoom } = zoomCapability
    return {
      [Capability.CALENDAR_SOURCE]: calendarSource,
      [Capability.CONTACT_SOURCE]: contactSource,
      [Capability.FINANCIAL_PLANNING]: financialPlanning,
      [Capability.MAIL]: mail,
      [Capability.ZOOM]: zoom,
      isLoading: isCalendarLoading || isContactLoading || isFPLoading || isMailLoading || isZoomLoading,
    }
  }, [calendarCapability, contactCapability, financialPlanningCapability, mailCapability, zoomCapability])
}
